import { F0ActionBar } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

import EnsureSaveDialog from 'modules/forms/components/newFormEditor/EnsureSaveDialog'

interface FormEditorActionsProps {
  isDirty: boolean
  onSave: () => Promise<void>
  onDiscard: () => void
}

export const FormEditorActions = ({ isDirty, onSave, onDiscard }: FormEditorActionsProps) => {
  return (
    <>
      {isDirty && (
        <F0ActionBar
          isOpen
          variant="light"
          primaryActions={[{ label: i18n.t('forms.action_bar.save'), onClick: onSave }]}
          secondaryActions={[{ label: i18n.t('forms.action_bar.discard'), onClick: onDiscard }]}
          label={i18n.t('forms.action_bar.label')}
        />
      )}
      <EnsureSaveDialog isDirty={isDirty} onSave={onSave} />
    </>
  )
}
